import i18next from 'i18next';

i18next.addResources('es', 'LoginError', {
  title: 'Ha ocurrido un error: {{error}}',
  emailDomainError: 'Error: el dominio de correo electrónico debe ser @zerf.com.ar.',
  notVerifiedEmail:
    'Por favor revise su casilla de correo electrónico y verifique su cuenta antes de continuar',
  accept: 'Aceptar'
});
